import { render } from "./CookieWarningView.vue?vue&type=template&id=5d924883"
import script from "./CookieWarningView.vue?vue&type=script&lang=js"
export * from "./CookieWarningView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__